import axios, { AxiosResponse } from 'axios';
import { storeToRefs } from 'pinia';
import { useAuthStore } from '../stores/auth'; // ใช้ relative path ให้ตรงกับโปรเจกต์

export interface HttpOptions {
	headers?: Record<string, string>;
	params?: Record<string, string | number>;
}

export const endpoint = 'https://sncg168.com/v1/tm/prd';

function getToken(): string | null {
	// ดึง token จาก Pinia
	const auth = useAuthStore();
	const { token } = storeToRefs(auth);
	return token.value;
}

const axiosInstance = axios.create({
	baseURL: endpoint,
	headers: {
		Accept: 'application/json',
	},
	timeout: 10000,
});

axiosInstance.interceptors.request.use((config) => {
	const token = getToken();
	if (token) {
		config.headers = config.headers || {};
		config.headers['Authorization'] = `Bearer ${token}`;
	}
	return config;
});

axiosInstance.interceptors.response.use(
	(response: AxiosResponse) => response,
	(error) => {
		const status = error?.response?.status;

		switch (status) {
			case 400:
				console.warn('Bad Request (400)');
				break;
			case 401:
				console.warn('Unauthorized (401)');
				break;
			case 404:
				console.warn('Not Found (404)');
				break;
			case 500:
				console.error('Server Error (500)');
				break;
		}

		return Promise.reject(error);
	}
);

export const http = {
	async get<T>(path: string, options?: HttpOptions): Promise<T> {
		try {
			const response = await axiosInstance.get<T>(path, {
				headers: options?.headers,
				params: options?.params,
			});
			return response.data;
		} catch (err) {
			throw formatHttpError(err);
		}
	},

	async post<T>(path: string, data: any, options?: HttpOptions): Promise<T> {
		try {
			const response = await axiosInstance.post<T>(path, data, {
				headers: {
					'Content-Type': 'application/json',
					...(options?.headers || {}),
				},
				params: options?.params,
			});
			return response.data;
		} catch (err) {
			throw formatHttpError(err);
		}
	},
};

function formatHttpError(error: any): Error {
	if (axios.isAxiosError(error)) {
		const message = error.response?.data?.message || error.message;
		return new Error(message);
	}
	return new Error('Unknown error occurred');
}
